import script from "./CountDown.vue?vue&type=script&setup=true&lang=js"
export * from "./CountDown.vue?vue&type=script&setup=true&lang=js"

import "./CountDown.vue?vue&type=style&index=0&id=4715edaf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4715edaf"]])

export default __exports__